import { Injectable } from '@angular/core';

import { HttpService } from '../core/http/http.service';

import { IPremises, IAddress, IBrand, IStoreFormat, IStore, ICostCenter, IStoreFloor, IStoreValidation } from '../_entities';


@Injectable()
export class StoreService {


	private getStoreFormatsPromise: Promise<IStoreFormat[]>;
	private getBrandsPromise: Promise<IBrand[]>;
	private getCostCentersPromise: Promise<ICostCenter[]>;

	constructor(private readonly httpService: HttpService) { }

	validateStore(storeNbr: number, isTemporary: boolean, popularName: string): Promise<IStoreValidation> {
		var data = {};
		data["popularName"] = popularName;
		data["storeNbr"] = storeNbr;
		data["isTemporary"] = isTemporary;

		return this.httpService.post<IStoreValidation>("/api/store/verify", data);
	}

	getStoreList(): Promise<any[]> {
		return this.httpService.get<any[]>(`/api/store`);
	}


	getRegionStoreList(): Promise<any[]> {
		return this.httpService.get<any[]>(`/api/store-by-region`);
	}


	getStore(storeId: number): Promise<IStore> {
		return this.httpService.get<IStore>(`/api/store/${storeId}`);
	}

	public getStoreFloors(storeId: number): Promise<IStoreFloor[]> {
		return this.httpService.get<IStoreFloor[]>(`api/store/${storeId}/storefloor`);
	}

	public deleteStoreFloor(storeFloorId: number): Promise<IStoreFloor[]> {
		return this.httpService.delete(`api/storefloor/${storeFloorId}`);
	}

	getStoreFormats(): Promise<IStoreFormat[]> {
		if (!this.getStoreFormatsPromise) {
			this.getStoreFormatsPromise = this.httpService.get<IStoreFormat[]>("api/storeformat");
		}
		return this.getStoreFormatsPromise;
	}

	getBrands(): Promise<IBrand[]> {
		if (!this.getBrandsPromise) {
			this.getBrandsPromise = this.httpService.get<IBrand[]>("api/brand");
		}
		return this.getBrandsPromise;
	}

	getCostCenters(): Promise<ICostCenter[]> {
		if (!this.getCostCentersPromise) {
			this.getCostCentersPromise = this.httpService.get<ICostCenter[]>("api/templates/costcenter");
		}
		return this.getCostCentersPromise;
	}

	addStoreFloor(storeId: number, premisesFloorId: number): Promise<IStoreFloor> {
		return this.httpService.post<IStoreFloor>(`/api/store/${storeId}/storefloor`, { premisesFloorId: premisesFloorId });
	}

	addNewStore(store: {
		premisesId: number;
		popularName: string;
		isTemporary: boolean;
		storeNumber: number;
		salesCountryCode: string;
		fiscalCountryCode: string;
		brandCode: string;

		classification?: string,
		formatName: string;
		operationType: string;
		floors: any[];
	}): Promise<IStore> {
		return new Promise((resolve, reject) => {
			this.httpService.post<IStore>("/api/store", store)
				.then(result => {
					resolve(result);
				}, error => reject(error));
		});
	}

	addNewPremises(premises: {
		popularName: string;
		costCenterName: string;
		locationTypeName: string;
		siteTypeName: string;
		location: { countryCode: string, regionName: string, cityName: string };
		region: { countryCode: string, name: string };
		floors: { index: number, name: string, contractArea: number, salesArea?: number, ceilingHeight?: number }[];
	}): Promise<IPremises> {
		return new Promise((resolve, reject) => {

			console.dir(premises);

			this.httpService.post<IPremises>("/api/premises", premises)
				.then(result => {
					resolve(result);
				}, error => reject(error));
		});
	}


	public patchStoreFloor(storeFloorId: number, prop: string, value: any): Promise<IStoreFloor> {
		const patches = [{ "op": "replace", "path": `/${prop}`, "value": value }];
		return this.httpService.patch<IStoreFloor>(`api/storefloor/${storeFloorId}`, patches);
	}

	addPremisesAddress(premisesIdentifier: string, address: {
		type: string;
		address1: string;
		address2?: string;
		postalCode: string;
		city: string;
		countryCode: string;
	}): Promise<IAddress> {
		return new Promise((resolve, reject) => {
			this.httpService.post<IAddress>(this.getPremisesUrl(premisesIdentifier, 'address'), address)
				.then(result => {
					resolve(result);
				}, error => reject(error));
		});
	}

	private getPremisesUrl(premisesIdentifier: string, path: string = "") {
		return "/api/" + premisesIdentifier + "/premises/" + path;
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/store.service.ts